import CustomIcon from "@/components/ui/custom-icon";
import { Navigation } from "swiper/modules";
import { useHomeData } from "../../hooks/useHomeData";
import { AdminHomePageSliderResourceTypeEnum } from "@/api/generated-api";
import { useMedia } from "@/hooks/system/useMedia";
import { Swiper, SwiperSlide } from "swiper/react";
import Image from "next/image";
import clsx from "clsx";
import { ButtonLink } from "@/components/ui/button";
import S from "./index.module.scss";

const BANNER_SWIPER_PREV_CLASS = "banner-swiper-button-prev";
const BANNER_SWIPER_NEXT_CLASS = "banner-swiper-button-next";

const BannerSection = () => {
  const { home } = useHomeData();
  const { isMobile, isClient } = useMedia();

  return (
    <div className={S.bannerSwiper}>
      <Swiper
        modules={[Navigation]}
        speed={600}
        navigation={{
          nextEl: `.${BANNER_SWIPER_NEXT_CLASS}`,
          prevEl: `.${BANNER_SWIPER_PREV_CLASS}`,
        }}
      >
        {home?.slider?.map(slide => (
          <div className={S.bannerSwiperSlide} key={slide.title}>
            <SwiperSlide key={slide.title}>
              <section className={S.wrapper}>
                {slide.type === AdminHomePageSliderResourceTypeEnum.Image ? (
                  <Image
                    className={S.customImg}
                    src={isMobile && isClient ? slide.bg.mobile : slide.bg.desk}
                    alt="banner"
                    width={1600}
                    height={800}
                  />
                ) : (
                  <video className={S.customVideo} loop={true} autoPlay={true} muted={true} playsInline>
                    <source src={slide.bg.desk} type="video/mp4" />
                  </video>
                )}

                <div className={S.titleWrapper}>
                  {isClient && (
                    <h1
                      className={S.title}
                      dangerouslySetInnerHTML={{ __html: slide.title }}
                      style={{ color: slide?.title_color || "#ffffff" }}
                    />
                  )}

                  {slide.description && isClient && (
                    <p
                      className={S.subtitle}
                      dangerouslySetInnerHTML={{ __html: slide.description }}
                      style={{ color: slide.description_color || "#ffffff" }}
                    />
                  )}
                  {slide.button && (
                    <ButtonLink href={slide.button?.link as string} variant="white">
                      {slide.button?.title}
                    </ButtonLink>
                  )}
                </div>
              </section>
            </SwiperSlide>
          </div>
        ))}

        <div className={clsx(BANNER_SWIPER_PREV_CLASS, S.customNavArrow, S["customNavArrow--back"])}>
          <CustomIcon fileName={"chevron-right"} />
        </div>
        <div className={clsx(BANNER_SWIPER_NEXT_CLASS, S.customNavArrow)}>
          <CustomIcon fileName={"chevron-right"} />
        </div>
      </Swiper>
    </div>
  );
};

export default BannerSection;
